import { DATASET_LABELS } from './Conditional';
export var PROPERTY_TYPES;
(function (PROPERTY_TYPES) {
    PROPERTY_TYPES["array"] = "List";
    PROPERTY_TYPES["boolean"] = "True/False";
    PROPERTY_TYPES["number"] = "Number";
    PROPERTY_TYPES["string"] = "Text";
})(PROPERTY_TYPES || (PROPERTY_TYPES = {}));
const globalProperties = {
    is_loading: PROPERTY_TYPES.boolean,
};
const allAccountsProperties = {
    plan_info: {
        names: PROPERTY_TYPES.array,
        ids: PROPERTY_TYPES.array,
    },
};
const currentAccountProperties = {
    companies_trial_auto_upgrade: PROPERTY_TYPES.boolean,
    companies_trial_end_date: PROPERTY_TYPES.string,
    companies_trial_start_date: PROPERTY_TYPES.string,
    company_account_end_date: PROPERTY_TYPES.string,
    company_address: PROPERTY_TYPES.string,
    company_initial_engagement: PROPERTY_TYPES.boolean,
    created_at: PROPERTY_TYPES.string,
    currency: PROPERTY_TYPES.string,
    first_known_upgrade_date: PROPERTY_TYPES.string,
    has_been_in_companies_trial: PROPERTY_TYPES.boolean,
    has_modern_pricing_plan: PROPERTY_TYPES.boolean,
    id: PROPERTY_TYPES.number,
    is_chat_eligible: PROPERTY_TYPES.boolean,
    is_company_account: PROPERTY_TYPES.boolean,
    is_in_experts_mvp: PROPERTY_TYPES.boolean,
    is_premier_chat_eligible: PROPERTY_TYPES.boolean,
    is_team_account: PROPERTY_TYPES.boolean,
    is_trialing_companies: PROPERTY_TYPES.boolean,
    is_trialing_teams: PROPERTY_TYPES.boolean,
    is_trialing: PROPERTY_TYPES.boolean,
    is_unlimited: PROPERTY_TYPES.boolean,
    last_plan_change_at: PROPERTY_TYPES.string,
    logo_url: PROPERTY_TYPES.string,
    name: PROPERTY_TYPES.string,
    offer_returning_trial_extension: PROPERTY_TYPES.boolean,
    owner: {
        id: PROPERTY_TYPES.number,
        name: PROPERTY_TYPES.string,
        email: PROPERTY_TYPES.string,
    },
    paying: PROPERTY_TYPES.boolean,
    pays_manually: PROPERTY_TYPES.boolean,
    period_end: PROPERTY_TYPES.string,
    period_start: PROPERTY_TYPES.string,
    plan_group_id: PROPERTY_TYPES.number,
    plan_info: {
        id: PROPERTY_TYPES.number,
        name: PROPERTY_TYPES.string,
        metered_task_pricing: PROPERTY_TYPES.boolean,
        interval: PROPERTY_TYPES.string,
        allow_companies: PROPERTY_TYPES.boolean,
        allow_teams: PROPERTY_TYPES.boolean,
        allow_import_export: PROPERTY_TYPES.boolean,
    },
    surveys_submitted: {
        company_trial_onboarding: PROPERTY_TYPES.boolean,
        company_trial_exit: PROPERTY_TYPES.boolean,
    },
    team_account_end_date: PROPERTY_TYPES.string,
    teams_trial_auto_upgrade: PROPERTY_TYPES.boolean,
    teams_trial_end_date: PROPERTY_TYPES.string,
    trial_auto_upgrade: PROPERTY_TYPES.boolean,
    trial_end_date: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean,
};
const queryParameterProperties = {
    demo_source: PROPERTY_TYPES.string,
    utm_campaign: PROPERTY_TYPES.string,
    utm_medium: PROPERTY_TYPES.string,
    utm_source: PROPERTY_TYPES.string,
};
const userProperties = {
    banner_message: PROPERTY_TYPES.string,
    current_account_id: PROPERTY_TYPES.number,
    current_account_role: PROPERTY_TYPES.string,
    email: PROPERTY_TYPES.string,
    first_name: PROPERTY_TYPES.string,
    has_activated: PROPERTY_TYPES.boolean,
    has_active_zaps: PROPERTY_TYPES.boolean,
    has_signed_up: PROPERTY_TYPES.boolean,
    id: PROPERTY_TYPES.number,
    identity: PROPERTY_TYPES.number,
    is_developer: PROPERTY_TYPES.boolean,
    is_expert: PROPERTY_TYPES.boolean,
    is_high_value: PROPERTY_TYPES.boolean,
    is_logged_in: PROPERTY_TYPES.boolean,
    is_staff: PROPERTY_TYPES.boolean,
    is_temporary: PROPERTY_TYPES.boolean,
    last_login: PROPERTY_TYPES.string,
    last_name: PROPERTY_TYPES.string,
    organizations: PROPERTY_TYPES.array,
    photo_url: PROPERTY_TYPES.string,
    primary_organization: PROPERTY_TYPES.number,
    signup: PROPERTY_TYPES.string,
    since_signup: PROPERTY_TYPES.string,
    timezone: PROPERTY_TYPES.string,
    user_id: PROPERTY_TYPES.number,
    username: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean,
};
const userProfileProperties = {
    role_id: PROPERTY_TYPES.number,
    role_name: PROPERTY_TYPES.string,
    company_size_id: PROPERTY_TYPES.number,
    company_size_display_range: PROPERTY_TYPES.string,
    organization_name: PROPERTY_TYPES.string,
    inferred_organization_name: PROPERTY_TYPES.string,
    is_loading: PROPERTY_TYPES.boolean,
};
function getProperties(prefix, obj) {
    return Object.entries(obj).reduce((properties, [key, value]) => {
        if (value !== null && value.constructor.name === 'Object') {
            return [...properties, ...getProperties(`${prefix} - ${key}`, value)];
        }
        const dashSeparatedKeys = `${prefix} - ${key}`;
        return [
            ...properties,
            { label: dashSeparatedKeys, value: dashSeparatedKeys, helperText: value },
        ];
    }, []);
}
export const properties = [
    ...getProperties(DATASET_LABELS.global, globalProperties),
    ...[
        ...getProperties(DATASET_LABELS.allAccounts, allAccountsProperties),
        ...getProperties(DATASET_LABELS.currentAccount, currentAccountProperties),
        ...getProperties(DATASET_LABELS.queryParameters, queryParameterProperties),
        ...getProperties(DATASET_LABELS.session, userProperties),
        ...getProperties(DATASET_LABELS.userProfile, userProfileProperties),
    ].sort(),
];
//# sourceMappingURL=properties.js.map